import { useContext } from 'react';
import { ConfigContext } from '../providers/ConfigContext';
import useMakeApiRequest from './useMakeApiRequest';

const useVerifyRecaptchaToken = (reCaptchaToken: string) => {
  const { apiBase } = useContext(ConfigContext);
  const makeApiRequest = useMakeApiRequest('POST');

  const verifyRecaptchaToken = async (recaptchaToken: string) => {
    return await makeApiRequest(`${apiBase}/api/verify-recaptcha?reCaptchaToken=${recaptchaToken}`, {});
  };

  return [verifyRecaptchaToken];
}

export default useVerifyRecaptchaToken;